import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { InvestigationSection } from '../components/InvestigationSection';
import { WhyThisMattersSection } from '../components/WhyThisMattersSection';
import { DigitalBenefitsSection } from '../components/DigitalBenefitsSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-charcoal-900 selection:bg-patriotRed selection:text-white" data-id="element-79">
      <HeroSection data-id="element-80" />
      <div className="w-full max-w-4xl mx-auto border-t border-charcoal-700/50" aria-hidden="true" data-id="element-81" />
      <InvestigationSection data-id="element-82" />
      <div className="w-full max-w-4xl mx-auto border-t border-charcoal-700/50" aria-hidden="true" data-id="element-83" />
      <WhyThisMattersSection data-id="element-84" />
      <div className="w-full max-w-4xl mx-auto border-t border-charcoal-700/50" aria-hidden="true" data-id="element-85" />
      <SocialProofSection data-id="element-86" />
      <div className="w-full max-w-4xl mx-auto border-t border-charcoal-700/50" aria-hidden="true" data-id="element-87" />
      <DigitalBenefitsSection data-id="element-88" />
      <FooterSection data-id="element-89" />
    </main>;
}